import _ from 'lodash'
import loadJS from 'load-js/src/load-js.js'
const positions = {}
const head = positions.head = document.getElementsByTagName('head')[0]
positions.body = document.getElementsByTagName('body')[0]

export const addExternalCSS = function (paths, position) {
  if (!paths) {
    return
  }
  _.forOwn(_.castArray(paths), item => {
    const path = item.url || item;
    if (path) {
      const link = document.createElement("link")
      link.href = path
      link.type = "text/css"
      link.rel = "stylesheet"

      const positionElm = positions[position] || head
      positionElm.appendChild(link)
    }
  })
}

export const addInlineCSS = function (css, position) {
  if (!css) {
    return
  }
  const style = document.createElement("style");

  style.type = 'text/css'
  // This is required for IE8 and below.
  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
  const positionElm = positions[position] || head
  positionElm.appendChild(style)
}

export const addExternalJS = function (paths, callback) {
  if (!paths) {
    return
  }
  paths = _.filter(_.map(_.castArray(paths), path =>  {
    if (_.isString(path)) {
      return {url: path}
    }
    return path
  }))
  loadJS(paths).then(callback || (() => {}))
}

export const injectHtml = function (htmlString, target) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  setDocumentTitleFromFragment(doc);

  const insert = (parent, node, position) => {
    const imported = document.importNode(node, true);
    position === "top"
      ? parent.prepend(imported)
      : parent.appendChild(imported);
  };

  if (target.startsWith("head")) {
    const position = target.endsWith("top") ? "top" : "bottom";

    doc.head.querySelectorAll("style, link, meta").forEach(node => {
      insert(document.head, node, position);
    });
  }

  if (target.startsWith("body")) {
    const position = target.endsWith("top") ? "top" : "bottom";

    [...doc.body.childNodes]
      .filter(n => n.nodeName !== "SCRIPT")
      .forEach(node => {
        insert(document.body, node, position);
      });
  }

  doc.querySelectorAll("script").forEach(script => {
    const s = document.createElement("script");

    for (const attr of script.attributes) {
      s.setAttribute(attr.name, attr.value);
    }

    if (!script.src) {
      s.textContent = script.textContent;
    }

    // Script placement policy
    document.body.appendChild(s);
  });
}

export const setDocumentTitleFromFragment = function (doc) {
  const fragmentTitle = doc.head.querySelector("title");
  if (!fragmentTitle) return;

  const text = fragmentTitle.textContent?.trim();
  if (!text) return;

  let titleEl = document.head.querySelector("title");

  if (!titleEl) {
    titleEl = document.createElement("title");
    document.head.appendChild(titleEl);
  }

  titleEl.textContent = text;
}


export default {addExternalCSS, addInlineCSS, addExternalJS, injectHtml, setDocumentTitleFromFragment}
